module.exports = __webpack_public_path__ + "shoe.jpg?2d62a3ac5efcb246b4bc6246dad3df74";